import { render } from "./dayone.vue?vue&type=template&id=c96fce5c"
import script from "./dayone.vue?vue&type=script&lang=js"
export * from "./dayone.vue?vue&type=script&lang=js"

import "./dayone.vue?vue&type=style&index=0&id=c96fce5c&lang=scss"
script.render = render

export default script